export default __webpack_public_path__ + "static/Permit to Work-f5938ff2febaa531323104b138cc268b.jpg";